module.exports = __webpack_public_path__ + "static/how-to-join.009bbf95.png";